/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react';
import { Form, Label, Pane, Button, Flex, Text } from '@leverege/ui-elements';
import { useDispatch, useSelector } from 'react-redux';
import { ns } from '@leverege/i18n';
import { UI } from '@leverege/ui-redux';
import fileUtils from "./fileUtils.js";
import S from './ImagineImageEditor.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = ns('molten.imagine.forms.editors.ImagineImageEditor');
function ImagineImageEditor(props) {
  const {
    validator
  } = useContext(Form.Context);
  const [url, setUrl] = useState();
  const {
    attr,
    eventData,
    target
  } = props;
  const dispatch = useDispatch();
  const {
    delegate
  } = eventData;
  const value = validator.value(attr?.blueprint?.updatePath);
  const error = useSelector(state => {
    return UI.get(state, `imageError/${attr?.blueprint?.updatePath}`);
  });
  useEffect(() => {
    if (Array.isArray(value) && value[0] instanceof File) {
      setUrl(URL.createObjectURL(value[0]));
    } else if (Array.isArray(value) && target?.id) {
      const itemDelegate = delegate.item ? delegate.item(target.id) : delegate;
      dispatch(itemDelegate.resource(`resourceImage/${attr?.blueprint?.updatePath.slice(5)}`).get()).then(data => {
        const {
          data: {
            url
          }
        } = data;
        setUrl(url);
      });
    }
  }, [value]);
  if (value) {
    return /*#__PURE__*/_jsxs(Pane, {
      layout: "flex:colS",
      children: [/*#__PURE__*/_jsx(Label, {
        variant: "inputTitle",
        children: attr.displayName
      }), /*#__PURE__*/_jsxs(Flex, {
        variant: "rowM",
        align: "flex-start",
        children: [/*#__PURE__*/_jsx("img", {
          src: url,
          alt: "",
          className: S.image
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "colM",
          children: [/*#__PURE__*/_jsx(Label, {
            variant: "captionSmallBold",
            className: S.title,
            children: value[0]?.name
          }), /*#__PURE__*/_jsx(Label, {
            variant: "captionSmall",
            children: value[0] instanceof File && fileUtils.getBytesSize(value[0]?.size)
          }), /*#__PURE__*/_jsxs(Flex, {
            variant: "colM",
            children: [/*#__PURE__*/_jsx(Form.FileInput, {
              className: S.button,
              variant: "secondarySmallLeftIcon",
              name: attr?.blueprint?.updatePath,
              fileTypes: "image/*",
              t: t
            }), /*#__PURE__*/_jsx(Button, {
              className: S.button,
              variant: "dangerSmallLeftIcon",
              onClick: () => validator.onInputChange({
                data: attr?.blueprint?.updatePath,
                value: null
              }),
              children: t('delete')
            })]
          })]
        })]
      }), error ? /*#__PURE__*/_jsx(Text, {
        variant: "inputCaptionSmallError",
        children: error
      }) : /*#__PURE__*/_jsx(Form.Error, {
        variant: "inputCaptionSmallError",
        name: attr?.blueprint?.updatePath
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Pane, {
    layout: "flex:colS",
    children: [/*#__PURE__*/_jsx(Label, {
      variant: "inputTitle",
      children: attr.displayName
    }), /*#__PURE__*/_jsx(Form.FileInput, {
      variant: "uploadFile",
      name: attr?.blueprint?.updatePath,
      fileTypes: "image/*",
      t: t
    }), /*#__PURE__*/_jsx(Label, {
      variant: "helperText",
      children: t('caption')
    }), error ? /*#__PURE__*/_jsx(Text, {
      variant: "inputCaptionSmallError",
      children: error
    }) : /*#__PURE__*/_jsx(Form.Error, {
      variant: "inputCaptionSmallError",
      name: attr?.blueprint?.updatePath
    })]
  });
}
const type = 'resourceImage';
export default {
  editor: ImagineImageEditor,
  type
};